export enum CompanyChangeOfficerType {
  Appointment = 0,
  Removal = 1
}
